import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import { ITopicPath } from '../../../components/atoms/topicPath'
import ColumnAuthor002 from '../../../components/molecules/columnAuthor002'
import ColumnDetailInner0014 from '../../../components/molecules/columnDetailInner0014'
import ColumnRelationCards0014 from '../../../components/molecules/columnRelationCards0014'
import UsefulFunctionLayout016 from '../../../components/molecules/usefulFunctionLayout016'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import PopupBanner from '../../../components/molecules/popupBanner'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import useRouteParam from '../../../hooks/useRouteParam'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0014 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: '客先常駐での労働時間管理や36協定はどっちが適用？',
    },
  ]
  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="客先常駐での労働時間の管理や36協定の扱いはどう対応すべき？"
        description="客先常駐とは、会社の指示により別の会社へ出勤して働くことです。客先常駐社員は所属元の会社と雇用契約を交わしているため、労働時間や36協定の管理も所属元の会社となります。"
        ogUrl="https://kintaicloud.jp/column/details/C0014/"
        ogType="article"
        ogTitle="客先常駐での労働時間の管理や36協定の扱いはどう対応すべき？"
        ogDescription="客先常駐とは、会社の指示により別の会社へ出勤して働くことです。客先常駐社員は所属元の会社と雇用契約を交わしているため、労働時間や36協定の管理も所属元の会社となります。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0014.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0014 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor002 />

        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}

        {/** お役立ち機能 */}
        <UsefulFunctionLayout016 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        <ColumnRelationCards0014 />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0014

export const pageQuery = graphql`
  query C0014 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
